import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'iv-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent implements OnInit {
  // Initial styling
  imgStyles = {
    width: '40px',
    height: '40px',
    margin: '0 0 0 0'
  };

  @Input() avatarImg = '';
  @Input() avatarName =  '';
  @Input() avatarImgStyles = {};

  constructor() { }

  ngOnInit() {
    // Getting new styling, if any
    Object.assign(this.imgStyles, this.avatarImgStyles);
  }

  getAvatarInitials() {
    if (this.avatarName !== '') {
      const names = this.avatarName.split(' ');
      let initials = names[0].substring(0, 1).toUpperCase();
      if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
      }
      return initials;
    }
    return '';
  }

}
